module.exports = __webpack_public_path__ + "img/device_1001_2.5d34a5ff.svg";